import { useState, useEffect } from "react";

import { useAuth } from "./useAuth";

import { apiRoot } from "../constants";

const useEvent = (id, onCreatePage) => {
  const [event, setEvent] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const [isOwner, setIsOwner] = useState(false);
  const [hasJoinedEvent, setHasJoinedEvent] = useState(false);

  const { token, profile, authed } = useAuth();

  const [newMessage, setNewMessage] = useState(false);
  const discusionsEnabled = () => {
    // todo actually check the times
    return true;
  };
  useEffect(() => {
    if (!id) return;
    setLoading(true);
    // Currently no token needed to be able to see event
    const headers = {
      "Content-Type": "application/json",
    };
    if (authed) {
      headers["Authorization"] = `Token ${token}`;
    }
    fetch(`${apiRoot}/events/${id}`, {
      headers,
    })
      .then((resp) => {
        if (resp.status === 200) {
          resp.json().then((json) => {
            setEvent(json);
            setError(false);
            setLoading(false);
            if (profile) {
              const foundClient = json.clients?.find(
                (client) => client.id === profile.id
              );
              setHasJoinedEvent(foundClient);
              const io = json?.author?.id === profile?.id;
              setIsOwner(io);
            }
          });
        } else {
          setError(true);
          setEvent();
          setLoading(false);
        }
      })
      .catch((err) => {
        setError(true);
        setEvent();
        setLoading(false);
      });
  }, [id, profile, authed, token]);

  useEffect(() => {
    if (onCreatePage) {
      return;
    }
    let interval = setInterval(() => {
      if (!authed || !discusionsEnabled()) {
        return;
      }
      const headers = {
        "Content-Type": "application/json",
      };
      if (authed) {
        headers["Authorization"] = `Token ${token}`;
      }
      fetch(`${apiRoot}/events/${id}/discussions/`, {
        headers,
      })
        .then((resp) => {
          return resp.json();
        })
        .then((discussions) => {
          if (discussions.length > event.discussions.length) {
            setEvent({
              ...event,
              discussions,
            });
            setNewMessage(true);
          }
        });
    }, 1000 * 30);
    //destroy interval on unmount
    return () => clearInterval(interval);
  }, [id, onCreatePage, event, token, authed]);

  const createEvent = (data) => {
    return new Promise((res) => {
      fetch(`${apiRoot}/events/`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          Authorization: "Token " + token,
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.status !== 201) {
            setError(true);
            return;
          }
          return response.json();
        })
        .then((json) => {
          res(json.id);
        })
        .catch((err) => {
          setError(true);
        });
    });
  };

  const joinEvent = (id) => {
    return new Promise((res) => {
      fetch(`${apiRoot}/events/${id}/join/`, {
        method: "POST",
        headers: {
          Authorization: `Token ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((resp) => {
          resp.json().then(() => {
            if (resp.status === 200) {
              res(true);
              setError(false);
              const foundClient = event.clients.find(
                (client) => client.id === profile.id
              );
              if (!foundClient) {
                setEvent({
                  ...event,
                  clients: [...event.clients, { ...profile }],
                });
                setHasJoinedEvent(true);
              }
            } else {
              setError(true);
              res(false);
            }
          });
        })
        .catch(() => {
          setError(true);
          res(false);
        });
    });
  };

  const unjoinEvent = (id) => {
    return new Promise((res) => {
      fetch(`${apiRoot}/events/${id}/unjoin/`, {
        method: "POST",
        headers: {
          Authorization: `Token ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((resp) => {
          resp.json().then(() => {
            if (resp.status === 200) {
              res(true);
              setError(false);
              const foundClient = event.clients.find(
                (client) => client.id === profile.id
              );
              if (foundClient) {
                const remainingClients = event.clients.filter(
                  (client) => client.id !== profile.id
                );
                setEvent({
                  ...event,
                  clients: remainingClients,
                });
                setHasJoinedEvent(false);
              }
            } else {
              setError(true);
              res(false);
            }
          });
        })
        .catch(() => {
          setError(true);
          res(false);
        });
    });
  };

  const cancelEvent = (id) => {
    return new Promise((res) => {
      fetch(`${apiRoot}/events/${id}/cancel/`, {
        method: "POST",
        headers: {
          Authorization: `Token ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((resp) => {
          resp.json().then(() => {
            if (resp.status === 200) {
              res(true);
              setError(false);
            } else {
              setError(true);
              res(false);
            }
          });
        })
        .catch(() => {
          setError(true);
          res(false);
        });
    });
  };

  const createMessage = (data) => {
    return new Promise((res) => {
      fetch(`${apiRoot}/events/${id}/discussion_send/`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          Authorization: `Token ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.status !== 201) {
            setError(true);
            res(false);
          }
          return response.json();
        })
        .then((discussion) => {
          setEvent({
            ...event,
            discussions: [...event.discussions, discussion],
          });
          res(true);
        })
        .catch((err) => {
          setError(true);
        });
    });
  };

  return {
    event,
    hasJoinedEvent,
    isOwner,
    createEvent,
    joinEvent,
    unjoinEvent,
    cancelEvent,
    createMessage,
    error,
    loading,
    newMessage,
    setNewMessage,
  };
};

export default useEvent;
